import React from 'react';
import { Inbox } from 'lucide-react';
interface EmptyStateProps {
  title: string;
  description: string;
  action?: React.ReactNode;
  icon?: React.ComponentType<{
    className?: string;
  }>;
}
export function EmptyState({
  title,
  description,
  action,
  icon: Icon = Inbox
}: EmptyStateProps) {
  return <div className="flex flex-col items-center justify-center rounded-sm border border-dashed border-border bg-card px-6 py-14 text-center" data-id="element-551" data-mp="3n2mfk5jxvkng">
      <span className="flex h-10 w-10 items-center justify-center rounded-sm bg-muted" data-id="element-552" data-mp="3j22l59qr2v50">
        <Icon className="h-5 w-5 text-muted-foreground" aria-hidden="true" data-id="element-553" data-mp="3e912qrrc4dgo" />
      </span>
      <p className="mt-3 text-sm font-medium text-foreground" data-id="element-554" data-mp="39braz5gh3ppo">{title}</p>
      <p className="mt-1 max-w-md text-[13px] leading-relaxed text-muted-foreground" data-id="element-555" data-mp="34c50v4vxypl3">
        {description}
      </p>
      {action && <div className="mt-4" data-id="element-556" data-mp="2zb8n7zlsfp2h">{action}</div>}
    </div>;
}